import { useAccountContext } from '@seek/hirer-graphql-react';
import { setIntercomUserAttribute } from '@seek/hirer-intercom-adapter';
import { useEffect } from 'react';

interface IntercomConfigurationProps {
  numberOfJobs: number;
}

export const IntercomConfiguration = ({
  numberOfJobs,
}: IntercomConfigurationProps) => {
  const { accountContext } = useAccountContext();

  const email = accountContext?.currentUser?.email;
  const name = accountContext?.currentUser?.name;
  const isImpersonating = Boolean(
    accountContext?.headerFooterContext?.identityContext?.act,
  );

  useEffect(() => {
    if (email && name && !isImpersonating) {
      setIntercomUserAttribute({
        email,
        name,
        key: 'tour_trigger_jobs_list_has_visible_jobs',
        value: numberOfJobs > 0 ? 'true' : 'false',
      });
    }
  }, [numberOfJobs, email, name, isImpersonating]);

  return null;
};
